export const RESPONSE_CODES = {
    HTTP_SUCCESS: 200,
    SUCCESS: 200
};
export const HTTP_METHODS = {
    POST: 'post',
    GET: 'get',
    PUT: 'put',
    DEL: 'delete'
};
// 响应状态
export const RESPONSE_BUSINESS_CODES = {
    CODE: 'common.sucess',
    DESCRIBE: 'SUCCESS'
};
export const RESPONSE_ERROR_CODES = {
    TOKEN_EMPTY: 1212,
    LOGIN_URL_EMPTY: 1213
};
/**
 * 获取响应错误码的中文描述
 * @param code - 响应错误码
 * @returns 中文描述
 */
export function getResponseErrorCode(code) {
    const labels = {
        [RESPONSE_ERROR_CODES.TOKEN_EMPTY]: 'Token 为空',
        [RESPONSE_ERROR_CODES.LOGIN_URL_EMPTY]: '登录地址为空'
    };
    return labels[code] || 'Unknown error';
}
